// Tile metadata, ported verbatim from tiles.c.

export interface TileInfo {
  Is_Solid: number;
  Is_Special: number;
  Is_Passage: number;
  Is_Wall: number;
  Type: number;
}

function t(
  Is_Solid: number,
  Is_Special: number,
  Is_Passage: number,
  Is_Wall: number,
  Type: number
): TileInfo {
  return { Is_Solid, Is_Special, Is_Passage, Is_Wall, Type };
}

// tiles.c declares TileData[57] (the header's [48] is stale).
export const TileData: TileInfo[] = [
  t(1, 0, 0, 1, 0), //  0
  t(1, 0, 0, 1, 0), //  1
  t(1, 0, 0, 1, 0), //  2
  t(1, 0, 0, 1, 0), //  3
  t(1, 0, 0, 1, 0), //  4
  t(1, 0, 0, 1, 0), //  5
  t(1, 0, 0, 1, 0), //  6
  t(1, 0, 0, 1, 0), //  7
  t(1, 0, 0, 1, 0), //  8
  t(1, 0, 0, 1, 0), //  9
  t(1, 0, 0, 1, 0), // 10
  t(1, 0, 0, 1, 0), // 11
  t(0, 0, 0, 0, 1), // 12
  t(1, 0, 1, 0, 2), // 13
  t(1, 0, 1, 0, 2), // 14
  t(1, 0, 1, 0, 2), // 15
  t(1, 0, 1, 0, 2), // 16
  t(1, 0, 0, 0, 3), // 17
  t(0, 0, 0, 0, 1), // 18
  t(0, 0, 0, 0, 1), // 19
  t(0, 0, 0, 0, 1), // 20
  t(1, 0, 0, 1, 4), // 21
  t(1, 0, 0, 1, 4), // 22
  t(1, 0, 0, 1, 4), // 23
  t(1, 0, 0, 1, 4), // 24
  t(0, 1, 0, 0, 5), // 25
  t(0, 1, 0, 0, 6), // 26
  t(0, 0, 0, 0, 7), // 27
  t(0, 1, 0, 0, 8), // 28
  t(0, 1, 0, 0, 8), // 29
  t(0, 1, 0, 0, 8), // 30
  t(0, 1, 0, 0, 8), // 31
  t(0, 1, 0, 0, 8), // 32
  t(0, 0, 0, 0, 1), // 33
  t(1, 0, 0, 0, 0), // 34
  t(1, 0, 0, 0, 0), // 35
  t(1, 0, 0, 0, 0), // 36
  t(1, 0, 0, 0, 0), // 37
  t(1, 0, 0, 1, 4), // 38
  t(1, 0, 0, 1, 4), // 39
  t(1, 0, 0, 1, 4), // 40
  t(1, 0, 0, 1, 4), // 41
  t(0, 0, 0, 0, 8), // 42
  t(0, 0, 0, 0, 1), // 43
  t(0, 0, 0, 0, 1), // 44
  t(1, 0, 0, 1, 0), // 45
  t(1, 0, 0, 1, 0), // 46
  t(1, 0, 0, 1, 0), // 47
  t(1, 0, 0, 1, 0), // 48
  t(1, 0, 0, 1, 0), // 49
  t(1, 0, 0, 1, 0), // 50
  t(1, 0, 0, 1, 0), // 51
  t(1, 0, 0, 1, 0), // 52
  t(0, 1, 0, 0, 8), // 53
  t(0, 0, 0, 0, 1), // 54
  t(0, 0, 0, 0, 1), // 55
  t(0, 0, 0, 0, 1), // 56
];

export const automap_cols: number[] = [
  140, // 0: Room wall
  192, // 1: Floor
  100, // 2: Passage
  255, // 3: Void
  120, // 4: Locked passage
  230, // 5: Checkpoint
  240, // 6: Closed chest
  200, // 7: Open chest
  230, // 8: Magic tile
  0, // 9: --
];

export function IsSolid(tile: number): number {
  return TileData[tile].Is_Solid;
}
